export default __webpack_public_path__ + "static/media/logo-card-1440w.0d929d53.png";